import React from 'react';
import { Message } from 'semantic-ui-react';
import UserActivityTable from '~/features/admin/UserActivity/UserActivityTable';
import { useUserContext } from '~/hooks';

export default function AdminUserActivity() {
  const { loggedInUser } = useUserContext();

  if (!loggedInUser?.isAdmin) {
    return <Message negative>Only admin users can view user activity logs.</Message>;
  }

  return (
    <div style={{ padding: '2rem' }}>
      <h1>User activity</h1>
      <UserActivityTable />
    </div>
  );
}

